import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  connect() {
    const checkbox = document.querySelector('input#toggle-password-visibility');
    checkbox.addEventListener('change', function() {
      const passwordInputs = document.querySelectorAll('input.password-field');
      passwordInputs.forEach(passwordInput => {
        if (checkbox.checked) {
          passwordInput.type = 'text';
        } else {
          passwordInput.type = 'password';
        }
      });
    });
  }
}
